import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import "./BottomNav.css";

export default function BottomNav() {
  const { user } = useAuth();
  const { t } = useTranslation("navbar");
  if (!user) return null;

  const tabClass = ({ isActive }) =>
    `bottomnav-tab${isActive ? " is-active" : ""}`;

  // NavLink (react-router v7) automatically sets aria-current="page" on the
  // active link, so we don't pass `aria-current` ourselves. Passing a function
  // value isn't supported by NavLink (only `className`/`style`/`children` are
  // function-form) and would result in no aria-current attribute being rendered.
  return (
    <nav className="bottomnav" aria-label={t("primaryNav")}>
      <NavLink to="/dashboard" className={tabClass}>
        <span aria-hidden="true" className="bottomnav-icon">⌂</span>
        <span className="bottomnav-label">{t("home")}</span>
      </NavLink>

      <NavLink
        to="/create"
        className={({ isActive }) =>
          `bottomnav-tab bottomnav-tab--primary${isActive ? " is-active" : ""}`
        }
      >
        <span aria-hidden="true" className="bottomnav-icon bottomnav-icon--primary">+</span>
        <span className="bottomnav-label">{t("create")}</span>
      </NavLink>

      <NavLink to="/tickets" className={tabClass}>
        <span aria-hidden="true" className="bottomnav-icon">▣</span>
        <span className="bottomnav-label">{t("tickets")}</span>
      </NavLink>

      <NavLink to="/validate" className={tabClass}>
        <span aria-hidden="true" className="bottomnav-icon">✓</span>
        <span className="bottomnav-label">{t("validate")}</span>
      </NavLink>

      <NavLink to="/settings" className={tabClass}>
        <span aria-hidden="true" className="bottomnav-icon">☺</span>
        <span className="bottomnav-label">{t("profile")}</span>
      </NavLink>
    </nav>
  );
}
